const KEY = "theme";  // "auto" | "light" | "dark"
const mq = typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;

export const getThemePref = () => localStorage.getItem(KEY) || "auto";

export function applyTheme(pref = getThemePref()) {
    const dark = pref === "dark" || (pref === "auto" && !!mq?.matches);
    document.documentElement.classList.toggle("dark", dark);
    document.querySelector('meta[name="theme-color"]')?.setAttribute("content", dark ? "#0F0F0E" : "#111110");
    return dark;
}

export function setThemePref(pref) {
    localStorage.setItem(KEY, pref);
    applyTheme(pref);
}

export function initTheme() {
    applyTheme();
    mq?.addEventListener?.("change", () => getThemePref() === "auto" && applyTheme("auto"));
}
